/* eslint-disable max-len */
export const validateEmailCodeTemplate = (code) => {
	const emailString =  //final
  `<tr>
    <td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
        <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
        Hi !
      </p>
        <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
        Below is your verification code: 
        </p>
      <h2>${code}</h2>
    </td>
  </tr>`

	return emailTemplateModifier(emailString)
}

export const subscriptionConfirmationEmailTemplate = (firstName) => {
	const emailString =
  `<tr>
    <td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
      <p>
        Hi${firstName ? ' ' + firstName : ''},
      </p>
      <p>
      	Time to see what AGGIE, by Audience Genomics, has to offer! Our AI is learning about your audience and your brand with every post. All you have to do is curate up to a month in advance and let us do the rest.
      </p>
      <p>
      	To get started, upload some of your own media, approve some posts and connect one or more social accounts. We'll send you a weekly digest of your scheduled posts.
		</p>
    </td>
  </tr>`

	return emailTemplateModifier(emailString)

}

export const subscriptionUpdationEmailTemplate = (firstName) => {
	const emailString =
					`<tr>
					<td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
						<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
						<h2>Hi ${firstName ? firstName : ''}!!</h2>
						</p>
						<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
							<h2>Congratulations! Your subscription has been updated.</h2>
						</p>
					</td>
				</tr>`

	return emailTemplateModifier(emailString)
}

export const userTeamConfirmationEmailTemplate = (email) => {
	const emailString =
					`<tr>
					<td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
						<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
						<h2>Hi!</h2>
						</p>
						<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
            <h2>You have recieved a request from ${email} to join your team, please login to AG ..</h2>
						</p>
					</td>
				</tr>`

	return emailTemplateModifier(emailString)
}

export const userTeamInvitationEmailTemplate = (recepientEmail, inviterEmail, token) => {
	const emailString =
					`<tr>
					<td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
						<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
            <br /><br /><p>Hi, ${recepientEmail} !</p>
            <p>${inviterEmail} has sent you an invitation to join us.</p>
						</p>
						<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
            Click the button below to get started.<br /><br />
						<a href="${window.location.origin}?token=${token}">
							<button style="border: 0; background: #141623; font-size: 20px; font-weight: bold; cursor: pointer; padding: 10px 30px; border-radius: 10px; color: #fff; font-family: Khyay-Regular, sans-serif;">Log In</button>
						</a><br />
						</p>
					</td>
				</tr>`

	return emailTemplateModifier(emailString)
}

export const loginViaEmailTemplate = (firstName) => {
	const emailString =
  `<tr>
  	<td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
  		<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
  			<br /><br />Hi ${firstName || 'User'}!<br /><br />Welcome to Aggie community, where real-time consumer insights will help you tune into your audience and hit all the right notes.      
  		</p>
  		<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
  			<br />Click the button below to get started.<br /><br />
  			<a href="${window.location.origin}?token=EMAIL_TOKEN">
            <button style="border: 0; background: #141623; font-size: 20px; font-weight: bold; cursor: pointer; padding: 10px 30px; border-radius: 10px; color: #fff; font-family: Khyay-Regular, sans-serif;">Log In</button>
  			</a>
  		</p>
  	</td>
  </tr>`

	return emailTemplateModifier(emailString)
}

export const publishViaEmailTemplate = (message, firstName, caption, image ) => {
	const emailString =
  `<tr>
    <td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
      <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
      Hi!
      </p>
      <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
      <p>${message || `This is a suggested post from ${firstName}:`}</p>
      </p>
      <br />
      ${caption ? `<b>Caption:</b><br /><p>${caption}</p><br />` : ''}
      <img src="${image}" alt="Post Image" style="width:400px" />
      <br />
      <a href="${image}">
      <button style="border: 0; background: #141623; font-size: 20px;
        font-weight: bold; cursor: pointer; padding: 10px 30px; border-radius: 10px; color: #fff;font-family: Khyay-Regular, sans-serif;">Download</button>
      </a><br /><br />
    </td>
  </tr>`

	return emailTemplateModifier(emailString)

}

export const removeBgCreditExpriredMailTemplate = (firstName) => {
	const emailString =
 `<tr>
  	<td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
  		<p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
  			<br /><br />Hello ${firstName || 'Admin Team'}!<br /><br />
        This is to notify you that your remove.bg library credits have been exhausted.
        Please take action to replenish the credits 
  		</p>
  	</td>
  </tr>`

	const emailTemplateString =
  `<body style="font-family: Khyay-Regular, sans-serif; -webkit-font-smoothing: antialiased; font-size: 16px; line-height: 1.3; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; background-color: #f4f5f6; margin: 0; padding: 0; width: 100%; min-width:100%;">
    <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="body" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #f4f5f6; width: 100%;" width="100%" bgcolor="#f4f5f6">
      <tbody style="width: 100%;">
        <tr>
          <td class="container" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; max-width: 100%; padding: 0; width: 100%; margin: 0 auto;" width="100%" valign="top">
            <div class="content" style="box-sizing: border-box; display: block; margin: 0 auto; max-width: 100%; padding: 0;">
              <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="main" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt;background-color: linear-gradient(151.09deg, #EFFFF8 2.36%, #E7F3FF 50.2%, #EFFFF8 100%); border: 1px solid #eaebed; border-radius: 16px; width: 100%;" width="100%">
                <!-- START MAIN CONTENT AREA -->
                  <tr>
                    <td align="center" style="padding: 16px 0px;">
                      <img src="https://dev.letaggiedoit.com/images/emailHeaderFilled.png" alt="AG-email-logo"
                        style="display: block; max-width: 100%; height: auto;">
                    </td>
                  </tr>
                  ${emailString}
                  <tr>
                  <td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding: 24px; padding-top: 10px;" valign="top">
                    <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
                    Best,<br />The Aggie Success Team
                    </p>
                  </td>
                </tr>
      </table>
      </div>
      </td>
      </tr>
      </tbody>
      </table>
    </body>`

	return emailTemplateString
}

export const emailTemplateModifier = (emailTemplate) => {

	const emailTemplateString = `  
    <body style="font-family: Khyay-Regular, sans-serif; -webkit-font-smoothing: antialiased; font-size: 16px; line-height: 1.3; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; background-color: #f4f5f6; margin: 0; padding: 0; width: 100%; min-width:100%;">
    <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="body" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; background-color: #f4f5f6; width: 100%;" width="100%" bgcolor="#f4f5f6">
      <tbody style="width: 100%;">
        <tr>
          <td class="container" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; max-width: 100%; padding: 0; width: 100%; margin: 0 auto;" width="100%" valign="top">
            <div class="content" style="box-sizing: border-box; display: block; margin: 0 auto; max-width: 100%; padding: 0;">
              <table role="presentation" border="0" cellpadding="0" cellspacing="0" class="main" style="border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt;background-color: linear-gradient(151.09deg, #EFFFF8 2.36%, #E7F3FF 50.2%, #EFFFF8 100%); border: 1px solid #eaebed; border-radius: 16px; width: 100%;" width="100%">
                <!-- START MAIN CONTENT AREA -->
                  <tr>
                    <td align="center" style="padding: 16px 0px;">
                      <img src="https://dev.letaggiedoit.com/images/emailHeader.jpg" alt="AG-email-logo"
                        style="display: block; max-width: 100%; height: auto;">
                    </td>
                  </tr>
                  ${emailTemplate}
                  <tr>
                  <td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding: 24px; padding-top: 10px;" valign="top">
                    <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
                          If you have any issues, let us know and we'll be happy to help.
                    </p>
                    <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
                    Best,<br />The Aggie Success Team
                    </p>
                  </td>
                </tr>
      </table>
      </div>
      </td>
      </tr>
      </tbody>
      </table>
    </body>`

	return emailTemplateString
}

export const approveScheduledPostEmailTemplate = (posts) => {
	const emailString =
		`<tr>
			<td class="wrapper" style="font-family: Khyay-Regular, sans-serif; font-size: 16px; vertical-align: top; box-sizing: border-box; padding:0px 24px;" valign="top">
			  <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
			  Hi!
			  </p>
			  <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
				  <p>You have scheduled posts for this week. Take a moment to review and cancel any posts you don't want sent.</p>
			  </p>
			  <p style="font-family: Khyay-Regular, sans-serif; font-size: 16px; font-weight: normal; margin: 0; margin-bottom: 16px; color: #09090F;">
				  <p>Please note, all of these posts are already approved and will be sent unless you select 'Cancel'.</p>
			  </p>
			  <br /><br />
			  <a href="${window.location.origin}/cancelpost?postID=${postID}">
			  	  <button style="border: 0; background: #141623; font-size: 20px; font-weight: bold; cursor: pointer; padding: 10px 30px; border-radius: 10px; color: #fff; font-family: Khyay-Regular, sans-serif;">
			  	  	Cancel Post
			  	  </button>
			  </a>
			  <br />
			  ${caption ? `<b>Caption:</b><br /><p>${caption}</p><br />` : ''}
			  <img src="${image}" alt="Post Image" style="width:400px" />
			  <br />
			  <a href="${image}">
			  </a><br />
			</td>
		  </tr>`

	return emailTemplateModifier(emailString)
}
